import { Component } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { AuthService } from './shared/services/auth.service';
import { type AuthSession } from 'aws-amplify/auth';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'uam';
  constructor(
    private cookieService: CookieService,
    private authService: AuthService,
    private router: Router,
    private _activated_route: ActivatedRoute,
  ) {

  }
  ngOnInit() {
    this.authService.checkCurrentUserPromise().then(user => {
      console.log("check the current user", user);
    }).catch(err => {
      console.log("error gettting", err);
      // this.router.navigate(['/auth'])
      //Redirect to login screen
    });

    this.authService.fetchUserAttributesPromise().then(session => {
    }).catch(err => {
    });


    // userPoolClientId: environment.amplify.Auth.Cognito.userPoolClientId,
    // userPoolId: environment.amplify.Auth.Cognito.userPoolId,

    this.authService.fetchAuthSessionPromise().then(session => {
      // console.log("start of fetch auth session")
      let refreshToken = localStorage.getItem('CognitoIdentityServiceProvider.' + environment.amplify.Auth.Cognito.userPoolClientId + '.' + session.userSub + '.' + 'refreshToken');
      let deviceKey = session?.tokens?.accessToken.payload['device_key'];

      let currentTimeApp = Date.now() / 1000;
      let expiration = session?.tokens?.idToken?.payload.exp;
      if (expiration && expiration < currentTimeApp) {
        // console.log("token is caput")

        this.router.navigate(['/auth']);
      }
      else {
        if (session?.tokens?.idToken !== null && typeof session?.tokens?.idToken !== 'undefined') {
          this.cookieService.set('uam-id-token', session?.tokens?.idToken?.toString() as string, { domain: environment.cookieInfo.cookieStorage.domain });
        }
        if (refreshToken !== null && typeof refreshToken !== 'undefined') {
          this.cookieService.set('uam-refresh-token', refreshToken as string, { domain: environment.cookieInfo.cookieStorage.domain });
        }
        if (deviceKey !== null && typeof deviceKey !== 'undefined') {
          this.cookieService.set('uam-device-key', deviceKey as string, { domain: environment.cookieInfo.cookieStorage.domain });
        }
      }
      //Compare vs current time to see if token is still valid.
    }).catch(err => {
      console.log("could not fetch auth session");
    });
  }
}
